var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"blocked-page"},[_c('div'),_c('div',{staticClass:"blocked-page__text"},[_c('p',{staticClass:"blocked-page__text-content"},[_vm._v(_vm._s(_vm.message))])]),_c('Logo',{staticClass:"logo-bottom"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }